export class SuppressionReasonFilter {
    public IncludeInactive?: boolean;
}

export default SuppressionReasonFilter;